﻿document.language = navigator.language.substring(0, 2);
console.log("Here's the locale ID -> " + document.language);